<template>
    <div>
        <div class="d-flex flex-column gap-2 ans-q-container" v-for="(question,idx) in this.template.trueOrFalse"
             :key="idx">
            <div>Question {{idx+1}}</div>
            <div class="q-content">{{question['content']}}</div>
            <div class="d-flex gap-3">
                <div v-for="(a,index) in question.answers" class="d-flex gap-3 ans-content">
                    <input @click="checkHandler($event, index ,idx)"
                           :id="'trueFalse-'+idx+'-'+index" type="radio"
                           :name="'trueFalse-'+idx"
                           :value="true" v-model="a.is_selected" class="form-check-input"/>
                    <label :for="'trueFalse-'+idx+'-'+index" class="form-check-label">{{typeof a.value === "object" ? a.value[0] : a.value}}</label>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    export default {
        name: 'trueOrFalse-component',
        data() {
            return {}
        },
        async mounted() {
        },
        props: ['template', 'userAnswers'],
        methods: {
            checkHandler(e, aidx, idx) {
                console.log(this.userAnswers);
               this.userAnswers.answers.forEach((answer,index) => {

                    if(answer['question_id'] === this.template.trueOrFalse[idx]['answers'][aidx]['question_id']){
                        this.userAnswers.answers.splice(index, 1);
                    }

                });
                this.userAnswers.answers.push({...this.template.trueOrFalse[idx]['answers'][aidx]});
                console.log(this.userAnswers.answers)
                // this.template.trueOrFalse[idx].answers.forEach((answer, index) => {
                //     if (aidx !== index) {
                //         answer.is_selected = false;
                //     } else {
                //         answer.is_selected = true;
                //     }
                // });
                this.template.changeFlag = true;
            }
        }
    }
</script>

<style scoped>
    .form-check-input {
        border: 1px solid #e95626 !important;;
        background-color: transparent !important;
    }

    .form-check-input:checked {
        background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e") !important;
        border: 2px solid var(--border-color-data-table) !important;;
        background-color: #e95626 !important;
        box-shadow: 0 0 0 1px #e95626 !important;
    }
</style>